import { FC } from 'react';
import { AdditionalService } from '@services';
import { Box, Stack, Typography } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps } from '@components/common';
import { PackageDealAndServiceLogoViewer } from '@components/portal/package-deals';

export interface IWizardServiceDetailDialogProps extends IVoltaageModalDialogProps {
	entity?: AdditionalService;
}

export const WizardServiceDetailDialog: FC<IWizardServiceDetailDialogProps> = ({ entity, ...props }) => {
	return (
		<VoltaageModalDialog maxWidth="sm" titleProps={{ sx: { height: 64 } }} {...props}>
			{entity ? (
				<Box sx={{ padding: 5, paddingTop: 0 }}>
					<Stack direction="column" spacing={4} alignItems="center">
						<Stack direction="row" alignItems="center">
							<PackageDealAndServiceLogoViewer src={entity.logoUrl || ''} />
							<Stack direction="column" spacing={0}>
								<Typography variant="h5">{entity.name}</Typography>
								{entity.summary ? <Typography>{entity.summary}</Typography> : null}
							</Stack>
						</Stack>
						{entity.description ? <Typography textAlign="center">{entity.description}</Typography> : null}
					</Stack>
				</Box>
			) : null}
		</VoltaageModalDialog>
	);
};
